<template>
  <el-dialog
    title="选择出生日期"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
    width="800px"
    center
    append-to-body
    @close="onClose">
    <div class="dialog-wrapper">
      <el-radio-group v-model="currentDateType">
        <el-radio-button label="0">阳历(公历)</el-radio-button>
        <el-radio-button label="1">阴历(农历)</el-radio-button>
      </el-radio-group>
      <div style="width: 100%; display: flex; flex-direction: row; align-items: center; justify-content: center; margin-top: 30px;">
        <el-select style="width: 100px" v-model="currentYear" placeholder="年份" @visible-change="handleYearVisibleChange" ref="selectYearRef">
          <el-option v-for="item in years" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <span style="margin-left: 10px; margin-right: 40px; font-size: 18px">年</span>
        <el-select style="width: 100px" v-model="currentMonth" placeholder="月份" @visible-change="handleMonthVisibleChange" ref="selectMonthRef">
          <el-option v-for="item in months" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <span style="margin-left: 10px; margin-right: 40px; font-size: 18px">月</span>
        <el-select style="width: 100px" v-model="currentDay" placeholder="日期" @visible-change="handleDayVisibleChange" ref="selectDayRef">
          <el-option v-for="item in days" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <span style="margin-left: 10px; margin-right: 40px; font-size: 18px" v-show="currentDateType == '0'">日</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-dialog-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="btn-dialog-confirm" type="primary" @click="setBirthdayData">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import date from "../../js/date";
import calendar from "js-calendar-converter";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    birthday: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      years: [],
      months: [],
      days: [],
      currentYear: "",
      currentMonth: "",
      currentDay: "",
      currentDateType: "0",
      isDateTypeChanged: false,
    };
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.initDate();
      }
    },
    currentDateType: function (val) {
      this.isDateTypeChanged = true;
      if (this.visible) {
        if (val == "0") {
          var monthNumeric = date.convertLunarMonthToNumeric(this.currentMonth);
          var dayNumeric = date.convertLunarDayToNumeric(this.currentDay);
          var solarDate = calendar.lunar2solar(
            this.currentYear,
            parseInt(monthNumeric),
            dayNumeric,
            this.currentMonth.indexOf("闰") >= 0
          );
          this.currentYear = solarDate.cYear;
          this.currentMonth =
            solarDate.cMonth < 10 ? "0" + solarDate.cMonth : solarDate.cMonth;
          this.currentDay =
            solarDate.cDay < 10 ? "0" + solarDate.cDay : solarDate.cDay;
          this.months = date.glMonths();
          this.days = date.glDays(solarDate.cYear, solarDate.cMonth);
        } else {
          var lunarDate = calendar.solar2lunar(
            this.currentYear,
            this.currentMonth,
            this.currentDay
          );
          this.currentYear = lunarDate.lYear;
          this.currentMonth = lunarDate.IMonthCn.replace("月", "");
          this.currentDay = lunarDate.IDayCn;
          this.months = date.nlMonths(lunarDate.lYear);
          this.days = date.nlDays(
            lunarDate.lYear,
            lunarDate.lMonth,
            lunarDate.isLeap
          );
        }
      }
    },
    currentYear: function (val) {
      if (val && !this.isDateTypeChanged) {
        if (this.currentDateType == "0") {
          if (this.currentMonth) {
            this.days = date.glDays(val, this.currentMonth);
          } else {
            this.days = [];
          }
          if (
            this.currentDay &&
            this.currentDay > this.days[this.days.length - 1]
          ) {
            this.currentDay = "";
          }
        } else {
          this.months = date.nlMonths(val);
          if (
            this.currentMonth &&
            this.months.some(
              function (item) {
                return item == this.currentMonth;
              }.bind(this)
            ) == false
          ) {
            this.currentMonth = "";
            this.currentDay = "";
          }
          if (this.currentMonth) {
            this.days = date.nlDays(
              val,
              date.convertLunarMonthToNumeric(this.currentMonth),
              this.currentMonth.indexOf("闰")
            );
            if (
              this.currentDay &&
              this.days.some(
                function (item) {
                  return item == this.currentDay;
                }.bind(this)
              ) == false
            ) {
              this.currentDay = "";
            }
          } else {
            this.days = [];
          }
        }
      }
    },
    currentMonth: function (val) {
      if (val && !this.isDateTypeChanged) {
        if (this.currentDateType == "0") {
          this.days = date.glDays(this.currentYear, val);
          if (
            this.currentDay &&
            this.currentDay > this.days[this.days.length - 1]
          ) {
            this.currentDay = "";
          }
        } else {
          this.days = date.nlDays(
            this.currentYear,
            date.convertLunarMonthToNumeric(val),
            val.indexOf("闰") >= 0
          );
          if (
            this.currentDay &&
            this.days.some(
              function (item) {
                return item == this.currentDay;
              }.bind(this)
            ) == false
          ) {
            this.currentDay = "";
          }
        }
      } else {
        this.isDateTypeChanged = false;
      }
    },
  },
  methods: {
    initDate: function () {
      var birthdayArray = [];
      if (this.birthday) {
        birthdayArray = this.birthday.split("-");
      } else {
        birthdayArray = ["2000", "06", "15"];
      }
      this.years = date.years();
      this.months = date.glMonths();
      this.days = date.glDays(birthdayArray[0], birthdayArray[1]);
      this.currentYear = birthdayArray[0];
      this.currentMonth = birthdayArray[1];
      this.currentDay = birthdayArray[2];
      this.currentDateType = "0";
    },
    onClose: function () {
      this.years = [];
      this.months = [];
      this.days = [];
      this.currentYear = "";
      this.currentMonth = "";
      this.currentDay = "";
      this.currentDateType = "0";
    },
    handleSelectScroll: function (refName, list, currentValue) {
      this.$nextTick(
        function () {
          var selectedIndex = list.findIndex(
            function (option) {
              return option == currentValue;
            }
          );
          if (selectedIndex >= 0) {
            var selectDropdown = this.$refs[refName].$refs.popper.$el.querySelector(
              ".el-select-dropdown__wrap"
            );
            var dropdownList = selectDropdown.querySelectorAll("li");
            dropdownList.forEach(function (item) {
              item.classList.remove("selected");
            });
            dropdownList[selectedIndex].classList.add("selected");
            if (selectDropdown) {
              var scrollTop = 0;
              if (selectedIndex > 6) {
                scrollTop = 34 * (selectedIndex - 6);
              }
              selectDropdown.scrollTop = scrollTop;
            }
          }
        }.bind(this)
      );
    },
    handleYearVisibleChange: function (visible) {
      if (visible) {
        this.handleSelectScroll("selectYearRef", this.years, this.currentYear);
      }
    },
    handleMonthVisibleChange: function (visible) {
      if (visible) {
        this.handleSelectScroll("selectMonthRef", this.months, this.currentMonth);
      }
    },
    handleDayVisibleChange: function (visible) {
      if (visible) {
        this.handleSelectScroll("selectDayRef", this.days, this.currentDay);
      }
    },
    setBirthdayData: function () {
      if (!this.currentYear) {
        this.$message("请选择出生年份");
        return;
      }
      if (!this.currentMonth) {
        this.$message("请选择出生月份");
        return;
      }
      if (!this.currentDay) {
        this.$message("请选择出生日期");
        return;
      }
      var result = { birthday: "", displayBirth: "", lunarBirthday: "" };
      if (this.currentDateType == "0") {
        var monthStr =
          this.currentMonth.length == 1
            ? "0" + this.currentMonth
            : this.currentMonth;
        var dayStr =
          this.currentDay.length == 1 ? "0" + this.currentDay : this.currentDay;
        var solarDate =
          this.currentYear + "年" + monthStr + "月" + dayStr + "日";
        result.birthday = this.currentYear + "-" + monthStr + "-" + dayStr;
        var lunarDateObj = calendar.solar2lunar(
          this.currentYear,
          this.currentMonth,
          this.currentDay
        );
        var flag = this.utils.afterDateFromCurrent(result.birthday);
        if (flag) {
          this.$message({
            message: "出生日期必须小于当前日期",
            type: "warning",
          });
          return;
        }
        result.displayBirth =
          "公历" +
          solarDate +
          "  农历" +
          lunarDateObj.lYear +
          "年" +
          lunarDateObj.IMonthCn +
          lunarDateObj.IDayCn;
        result.lunarBirthday =
          lunarDateObj.lYear +
          "年" +
          lunarDateObj.IMonthCn +
          lunarDateObj.IDayCn;
      } else {
        var lunarDate =
          this.currentYear + "年" + this.currentMonth + "月" + this.currentDay;
        var monthNum = date.convertLunarMonthToNumeric(this.currentMonth);
        var dayNum = date.convertLunarDayToNumeric(this.currentDay);
        var solarDateObj = calendar.lunar2solar(
          this.currentYear,
          parseInt(monthNum),
          dayNum,
          this.currentMonth.indexOf("闰") >= 0
        );
        var monthStr =
          solarDateObj.cMonth < 10
            ? "0" + solarDateObj.cMonth
            : solarDateObj.cMonth;
        var dayStr =
          solarDateObj.cDay < 10 ? "0" + solarDateObj.cDay : solarDateObj.cDay;
        var solarDate =
          solarDateObj.cYear + "年" + monthStr + "月" + dayStr + "日";
        result.birthday = solarDateObj.cYear + "-" + monthStr + "-" + dayStr;
        var flag = this.utils.afterDateFromCurrent(result.birthday);
        if (flag) {
          this.$message({
            message: "出生日期必须小于当前日期",
            type: "warning",
          });
          return;
        }
        result.displayBirth = "公历" + solarDate + "  农历" + lunarDate;
        result.lunarBirthday = lunarDate;
      }
      this.dialogVisible = false;
      this.currentDateType = "0";
      this.$emit("confirm", result);
    },
  },
};
</script>

<style scoped>
.dialog-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-wrapper >>> .el-radio-group {
  display: flex !important;
  font-size: 0;
}
.dialog-wrapper >>> .el-radio-button__inner {
  border-radius: 999px !important;
  padding: 0 22px !important;
  min-width: 130px !important;
  height: 40px !important;
  line-height: 38px !important;
  font-size: 16px !important;
  white-space: nowrap;
  box-sizing: border-box;
  margin: 0 10px ;
}
.dialog-wrapper >>> .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 999px !important;
}
.dialog-footer {
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 0 !important;
  text-align: center !important;
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}
.btn-dialog-cancel,
.btn-dialog-confirm {
  min-width: 150px;
  height: 44px;
  padding: 0 20px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  border-color: #009798;
  box-sizing: border-box;
}
.btn-dialog-cancel {
  margin: 0 !important;
  width: auto !important;
  background: #fff;
  color: #009798;
}
.btn-dialog-cancel:hover {
  background-color: #f3f9f8;
  border-color: #009798;
  color: #009798;
}
.btn-dialog-confirm {
  margin: 0 !important;
  width: auto !important;
  background-color: #009798;
  border-color: #009798;
  color: #fff;
}
.btn-dialog-confirm:hover {
  background-color: #007e7f;
  border-color: #007e7f;
  color: #fff;
}
</style>
